module.exports={
    "zhcn": {
        "立即观看直播": "立即观看直播",
        "立即下载Uplive": "立即下载Uplive",
        "全球嗨翻 实时互动": "全球嗨翻 实时互动",
        "点击右上角选择浏览器打开": "点击右上角选择浏览器打开"
    },
    "zhtw": {
        "立即观看直播": "立即觀看直播",
        "立即下载Uplive": "立即下載Uplive",
        "全球嗨翻 实时互动": "全球嗨翻 實時互動",
        "点击右上角选择浏览器打开": "點擊右上角選擇瀏覽器打開"
    },
    "zhhk": {
        "立即观看直播": "立即觀看直播",
        "立即下载Uplive": "立即下載Uplive",
        "全球嗨翻 实时互动": "全球High爆 實時互動",
        "点击右上角选择浏览器打开": "點擊右上角選擇瀏覽器打開"
    },
    "enus": {
        "立即观看直播": "Watch live stream now",
        "立即下载Uplive": "Download Uplive",
        "全球嗨翻 实时互动": "Let's party and rock the world",
        "点击右上角选择浏览器打开": "Click on the upper right corner to select the browser to open"
    },
    "jajp": {
        "立即观看直播": "すぐライブを見る",
        "立即下载Uplive": "すぐUpliveをダウンロード",
        "全球嗨翻 实时互动": "全世界熱狂　大フィーバー",
        "点击右上角选择浏览器打开": "右上をクリックしてブラウザで開く"
    },
    "idid": {
        "立即观看直播": "Ayo menonton siaran langsung sekarang",
        "立即下载Uplive": "Ayo download Uplive sekarang",
        "全球嗨翻 实时互动": "Penuh sensasi! Interaksi langsung",
        "点击右上角选择浏览器打开": "Klik di pojok kanan atas untuk memilih browser untuk membuka"
    },
    "vivn": {
        "立即观看直播": "Xem livestream ngay",
        "立即下载Uplive": "Tải Uplive ngay bây giờ",
        "全球嗨翻 实时互动": "Cùng livestream, cùng phấn khởi",
        "点击右上角选择浏览器打开": "Nhấp vào góc trên bên phải để chọn trình duyệt để mở"
    },
    "areg": {
        "立即观看直播": "شاهد البث المباشر الآن",
        "立即下载Uplive": "حمّل تطبيق Uplive الآن",
        "全球嗨翻 实时互动": "تعرف على أصدقاء جدد حول العالم!",
        "点击右上角选择浏览器打开": "انقر فوق الزاوية اليمنى العليا لتحديد المتصفح لفتحه"
    }
}


// WEBPACK FOOTER //
// ./js/lang/pack.js